import type { DigestSubscription } from "app/pages/sales-intelligence/sub-modules/signals-alerts/models/DigestSubscription";
import type {
    CrmIntegrationListProps } from "../../components/CrmIntegration/CrmIntegrationList/CrmIntegrationList";
import {
    CrmIntegrationList
} from "../../components/CrmIntegration/CrmIntegrationList/CrmIntegrationList";
import useCRMSignalsAlertsFrequencyMutation from "../../mutations/useCRMListsSignalsAlertsFrequencyMutation";
import EmailAlertButton from "app/pages/sales-intelligence/modules/lists/components/EmailAlertButton/EmailAlertButton";
import signalsAlertsTrackingService from "app/pages/sales-intelligence/sub-modules/signals-alerts/services/tracking/trackingService";

type CRMListItemWithAlertsProps = CrmIntegrationListProps & {
    digestSubscription?: DigestSubscription;
};

const CRMListItemWithAlertsContainer = (props: CRMListItemWithAlertsProps) => {
    const { crmSyncStatusName, objectType, digestSubscription } = props;
    const alertsFrequencyMutation = useCRMSignalsAlertsFrequencyMutation();

    const isPaused = digestSubscription?.status === "paused";

    const handleAlertsToggle = () => {
        const newStatus = isPaused ? "active" : "paused";
        const assetType = crmSyncStatusName === "hubspot" ? "hubspotList" : "salesforceList";
        const assetId = `${crmSyncStatusName}-${objectType}`;

        signalsAlertsTrackingService.trackAlertFrequencySelect(newStatus === "active" ? "Weekly" : "Paused");
        alertsFrequencyMutation.mutate({
            assetId,
            assetType,
            status: newStatus,
        });
    };

    return (
        <CrmIntegrationList
            {...props}
            renderSecondaryContent={() => (
                <EmailAlertButton
                    isPaused={isPaused}
                    onChange={handleAlertsToggle}
                />
            )}
        />
    );
};

export default CRMListItemWithAlertsContainer;
